import {
    DRIVER_LIST_RESPONCE,
    CHANGE_DRIVER_DEPOTS_REDUX_STATE,
    UPDATE_REDUX_STATE

} from "./actionTypes";

const INIT_STATE = {
    driverList: [],
};

/**
 * Reducer function for managing the state of depots.
 * @param {object} state - The current state of depots.
 * @param {object} action - The action object that contains the type and payload.
 * @returns The updated state of depots.
 */
const Driver = (state = INIT_STATE, action) => {
    switch (action.type) {

        case DRIVER_LIST_RESPONCE:
           
            state = {
                ...state,
                driverList: action.payload,
              }
              return state;

       case  CHANGE_DRIVER_DEPOTS_REDUX_STATE:
           state = {
               ...state,
               driverList: {data : action.payload},
            }
            return state;
     case UPDATE_REDUX_STATE:
        state = {
            ...state,
            driverList: action.payload,
        }
         return state;
              
        default:
            return state;
    }
};


export default Driver;